import _ from 'lodash';

import {
  INHERITED_VALUE_HINT,
  PropertyDataType,
  SENSITIVE_VALUE_MASK,
  STORED_VALUE_HINT,
} from 'constants/properties';

export const getIsPropertySensitive = definition =>
  !!(definition?.isSensitiveEffective ?? definition?.isSensitive);

export const getIsPropertyInputMasked = definition =>
  getIsPropertySensitive(definition) && definition?.dataType !== PropertyDataType.BOOLEAN;

export const getDisplayedPropertyValue = ({ value, isSensitive, hasValue }) =>
  isSensitive && (value || hasValue) ? SENSITIVE_VALUE_MASK : value;

export const getHasStoredPropertyValue = property => {
  if (_.isNil(property)) {
    return false;
  }

  if (property.hasLocalValue || property.hasGlobalValue) {
    return true;
  }

  return _.isNull(property.propertyValue) || !!property.propertyValue;
};

export const getMaskedValueHint = ({ isMaskedInput, hasStoredValue, hasInheritedValue }) => {
  if (!isMaskedInput) {
    return null;
  }

  if (hasStoredValue) {
    return STORED_VALUE_HINT;
  }

  return hasInheritedValue ? INHERITED_VALUE_HINT : null;
};

export const getIsClearedMaskedValue = ({ isMaskedInput, hasStoredValue, value }) =>
  !!isMaskedInput && !!hasStoredValue && !value;
